module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('img', {
    attrs: {
      "alt": "cover.jpg",
      "height": "675",
      "src": "images/cover.jpg",
      "width": "450"
    }
  }), _c('span', {
    staticClass: "t1"
  }, [_vm._v("㼍")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("Monsters and Men Box Set")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By R.W. Clinger")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Published by "), _c('a', {
    attrs: {
      "href": "http://www.jms-books.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("JMS Books LLC")])])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Visit "), _c('a', {
    attrs: {
      "href": "http://www.jms-books.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("jms-books.com")])]), _vm._v(" for more information.")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Copyright 2023 R.W. Clinger")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("ISBN 9781685505738")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05813928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/001.vue
// module id = 54
// module chunks = 0